const menuButton = document.getElementById('menuButton');
const navMenu = document.getElementById('navMenu');
const accordionButton = document.getElementById('accordionButton');
const accordionContent = document.getElementById('accordionContent');

if(menuButton) {
  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('open');
    navMenu.classList.toggle('open');
  });
}

if(accordionButton) {
  accordionButton.addEventListener('click', () => {
    accordionButton.classList.toggle('open');
    accordionContent.classList.toggle('open');
  });
}


const topSlider = new Swiper('#home-fv .swiper', {
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    el: '.swiper-pagination',
    clickable: true,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
});

const bottomSlider = new Swiper('.bottom-slider', {
  loop: true,
  navigation: {
    clickable: true,
  },
});


var parallaxTargets = null;
window.addEventListener("load",()=>{
	parallaxTargets = document.querySelectorAll("img[data-parallax]");
	if(parallaxTargets){
		parallaxTargets.forEach(p=>{p.style.objectFit="cover";});
		window.addEventListener("resize",parallaxHandler,{passive:true});
		window.addEventListener("scroll",parallaxHandler,{passive:true});
		parallaxHandler();
	}
});
function parallaxHandler(){
	parallaxTargets.forEach(p=>{
		let r = p.getBoundingClientRect();
		p.style.objectPosition = "center "+((r.top+r.height) / (window.innerHeight+r.height) * 100)+"%";
	});
}


// モーダルを開く関数
function openModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.style.display = 'block';
  }
}

// モーダルを閉じる関数
function closeModal(modal) {
  if (modal) {
    modal.style.display = 'none';
  }
}

// ボタンのクリックイベントを設定
window.onload = function () {
  // 各ボタンと対応するモーダルIDのマッピング
  const buttonToModalMap = {
    'modal-button01': 'myModal01',
    'modal-button02': 'myModal02',
    'modal-button03': 'myModal03',
    'modal-button04': 'myModal04',
    'modal-button05': 'myModal05',
    'modal-button06': 'myModal06',
  };

  // ボタンにクリックイベントを設定
  Object.keys(buttonToModalMap).forEach((buttonClass) => {
    const button = document.querySelector(`.${buttonClass}`);
    const modalId = buttonToModalMap[buttonClass];

    if (button) {
      button.addEventListener('click', () => openModal(modalId));
    }
  });

  // モーダルの閉じるボタンと外側クリックで閉じる処理
  const modals = document.querySelectorAll('.modal');
  modals.forEach((modal) => {
    const closeBtn = modal.querySelector('.modal-close');

    // 閉じるボタンのクリックで閉じる
    if (closeBtn) {
      closeBtn.addEventListener('click', (event) => {
        event.preventDefault();
        closeModal(modal);
      });
    }

    // モーダルの外側クリックで閉じる
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal(modal);
      }
    });

    // モーダル内のクリックを伝播させない
    const modalContent = modal.querySelector('.modal-content');
    if (modalContent) {
      modalContent.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  });
};


const swiper1 = new Swiper('#home-news .swiper-container', {
  slidesPerView: 1,
  centeredSlides: true,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  breakpoints: {
    767: {
      spaceBetween: 20,
    },
  },
});


const swiper2 = new Swiper('#home-how-to-use .swiper-container', {
  slidesPerView: 1.1,
  spaceBetween: 20,
  centeredSlides: true,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    767: {
      slidesPerView: 1.8,
      spaceBetween: 20,
    },
  },
});


const swiper3 = new Swiper('#home-case-studies .swiper-container', {
  slidesPerView: 1,
  spaceBetween: 20,
  centeredSlides: true,
  loop: true,
  loopAdditionalSlides: 1,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1900: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    1700: {
      slidesPerView: 3.5,
      spaceBetween: 20,
    },
    1500: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    500: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
  },
});


$(function() {
  $('#home-case-studies .swiper-slide').matchHeight();
  $('.home-blog-inner').matchHeight();
});


(function () {
  if (window.innerWidth < 768) {
    const faqItems = document.querySelectorAll('#home-faq li');
    const footerBtns = document.querySelectorAll('.footer-menu ul:nth-child(1) > li:nth-child(1)');

    // FAQセクションの動作
    faqItems.forEach(item => {
      const question = item.querySelector('.home-faq-question');
      const answer = item.querySelector('.home-faq-answer');

      if (question && answer) {
        question.addEventListener('click', () => {
          item.classList.toggle('open');
          question.classList.toggle('open');
          answer.classList.toggle('open');
        });
      }
    });

    // フッターメニューの動作
    footerBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        btn.classList.toggle('open');
        const nestedItems = btn.parentElement.querySelectorAll(':scope > li:nth-child(n+2)');

        nestedItems.forEach(nestedItem => {
          nestedItem.classList.toggle('open');
        });
      });
    });
  }
})();




$(window).on("scroll", function() {
  if ($(window).scrollTop() > 500) {
    $(".top-button").fadeIn();
  } else {
    $(".top-button").fadeOut();
  }
});